import AuthStore from '../stores/AuthStore'

const updateHeader = (options) => {
  const updatedOptions = { ...options }
  if (AuthStore.token !== '') {
    updatedOptions.headers = {
      ...updatedOptions.headers,
      'x-access-token': AuthStore.token,
    }
  } else {
    const tokenFromStorage = localStorage.getItem('token')
    if (tokenFromStorage) {
      updatedOptions.headers = {
        ...updatedOptions.headers,
        'x-access-token': tokenFromStorage,
      }
    }
  }
  return updatedOptions
}

export default async function fetchWrapper(url, options) {
  return fetch(url, updateHeader(options))
}
